import { Card, CardContent, CardHeader, IconButton, Stack, Typography } from '@mui/material';
import { Box, borderRadius } from '@mui/system';
import SpreadSheetIcon from 'Components/Icons/SpreadSheetIcon';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
// import SampleCsvSvg from 'assets/images/dashboard/import_csv-sample_image.svg';
// import WasteIcon from 'assets/images/icons/Waste.svg';
// import SpreadSheetIcon from 'assets/images/icons/Spreadsheet.svg';

const CustomCsvAttachmentBox = ({ onRemoveHandler, fileName }) => {
    const customCsvStyle = {
        width: '100%',
        maxWidth: '288px',
        margin: '0 auto',
        border: '1px solid #DEDEDF',
        borderRadius: '16px',
        backgroundColor: '#fff',
        padding: '16px',
        zIndex: 1,
        transition: '0.3s ease',
        position: 'relative',
        '&:hover': {
            backgroundColor: '#F0F0F0',
            boxShadow: '1px 1px 4px 0px rgba(0, 5, 124, 0.13)',

            '.MuiIconButton-root': {
                visibility: 'visible',
                opacity: '1'
            }
        }
    };
    return (
        <Stack className="csv-file" sx={{ minHeight: '250px' }} alignItems="center" justifyContent="center">
            <Stack sx={customCsvStyle} direction="row" gap={2}>
                <IconButton
                    onClick={onRemoveHandler}
                    sx={{
                        position: 'absolute',
                        top: '-12px',
                        right: '-12px',
                        width: '24px',
                        height: '24px',
                        background: '#7D7D82',
                        transition: '0.3s ease',
                        visibility: 'hidden',
                        opacity: '0',

                        '&:hover': {
                            background: '#7D7D82',
                            opacity: '0.75'
                        },

                        svg: {
                            width: '18px',
                            height: '18px',
                            path: {
                                fill: '#fff'
                            }
                        }
                    }}
                >
                    <CloseRoundedIcon />
                </IconButton>
                <Box
                    sx={{
                        width: '40px',
                        height: '40px'
                    }}
                >
                    <SpreadSheetIcon />
                </Box>
                <Stack gap={1.5}>
                    <Typography component={'h6'} variant="h6" color="#00214D" fontSize="1rem" fontWeight="500" lineHeight="1">
                        {fileName || 'Name of CSV'}
                    </Typography>
                    <Typography fontSize="1rem" color="#676767" lineHeight="0.75">
                        CSV
                    </Typography>
                </Stack>
            </Stack>
        </Stack>
    );
};
export default CustomCsvAttachmentBox;
